// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3hXuV","validationTips":"StatementDescriptor_validationTips__2M-y0"};